import { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router-dom';
import { FLOW_NAVIGATION_ACTIONS } from '../../../../flows/DynamicFlow/utilities/constants';
import useLodgeData from '../../../../hooks/ui_hooks/useLodgeData';
import useSeasonsFlow from '../../../../hooks/ui_hooks/useSeasonsFlow';
import routes from '../../../../routes';
import theme from '../../../ui-kit/themes/theme';
import { SummaryContent } from '../Content';
import { Divider } from '../Content/styles';
import SummaryAccordion from '../SummaryAccordion';
import { AdditionalCharges } from './Content/AdditionalCharges';
import PackagesList from './Content/PackagesList';
import SimpleSummaryDue from './SimpleSummaryDue';
import SimpleSummaryFooter from './SimpleSummaryFooter';
import SimpleSummaryHeader from './SimpleSummaryHeader';
import SimpleSummaryInfo from './SimpleSummaryInfo';
import SimpleSummaryParkingFeeWarning from './SimpleSummaryParkingFeeWarning';

export const SimpleSummary = ({
  operaCode,
  onChange,
  title,
  deletePackage,
  clearSelectedPackages,
  upsertPackage,
  total,
  productTitle,
  productDescription,
  promoCode,
  fullWidthDescription,
  description,
  price,
  navigationText,
  packagesList,
  taxes,
  showDueToday,
  dueToday,
  dueBeforeParty,
  sustainabilityFee,
  parkingFee,
  resortFee,
  leftTitle,
  leftContent,
  rightTitle,
  rightContent,
  onPaymentPage,
  includedList,
  remainingBalanceDueDate,
  splitPackagesByTabName,
  allowPackageUpdate,
  triggerDynamicStepNavigation,
  allowPackagesListLink,
  numberOfGuests,
  type,
  hideParkingFeeForBirthday
}) => {
  const { resortShortName } = useLodgeData();
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.md})`
  });
  const { isSeasonsFlow } = useSeasonsFlow();
  const history = useHistory();
  const onInfoLinkClick = () => {
    if (isSeasonsFlow) {
      window.location.href = `/${resortShortName}${routes.seasonpass.booking}?numberOfGuests=${numberOfGuests}&type=${type}`;
      return;
    }
    triggerDynamicStepNavigation(FLOW_NAVIGATION_ACTIONS.FLOW_TRIGGER_FIRST_STEP);
    if (isMobile) {
      history.push({
        search: '?openEditMobile=true'
      });
    }
  };
  const { resortDailyParkingFee } = useLodgeData();
  useEffect(() => {
    //We don't have packages in seasonpass payment page
    //==================================================
    if (isSeasonsFlow && packagesList.length > 0) {
      clearSelectedPackages();
    }
  }, [isSeasonsFlow, packagesList, clearSelectedPackages]);
  return (
    <SummaryAccordion
      total={total}
      onChange={onChange}
      shouldStartCollapsed={!onPaymentPage}
      title={title}
      isOnPaymentPage={onPaymentPage}>
      {({ expanded, isDesktop }) => {
        return (
          <>
            {expanded ? (
              <SummaryContent>
                <SimpleSummaryHeader
                  leftTitle={leftTitle}
                  leftContent={leftContent}
                  rightTitle={rightTitle}
                  rightContent={rightContent}
                  isSeasonsFlow={isSeasonsFlow}
                />
                <SimpleSummaryInfo
                  promoCode={promoCode}
                  fullWidthDescription={fullWidthDescription}
                  description={description}
                  productTitle={productTitle}
                  productDescription={productDescription}
                  price={price}
                  navigationText={navigationText}
                  onNavigateLinkClick={onInfoLinkClick}
                  includedList={includedList}
                />
                <Divider />
                {/*This is not needed for seasonpass flow*/}
                {!isSeasonsFlow ? (
                  <PackagesList
                    currentSelectedPackages={packagesList}
                    deletePackage={deletePackage}
                    splitPackagesByTabName={splitPackagesByTabName}
                    allowPackageUpdate={allowPackageUpdate}
                    upsertPackage={upsertPackage}
                    triggerDynamicStepNavigation={triggerDynamicStepNavigation}
                    allowPackagesListLink={allowPackagesListLink}
                  />
                ) : null}
                {onPaymentPage ? (
                  <AdditionalCharges
                    taxes={taxes}
                    sustainabilityFee={sustainabilityFee}
                    parkingFee={parkingFee}
                    resortFee={resortFee}
                    lodgeOperaCode={operaCode}
                  />
                ) : null}
              </SummaryContent>
            ) : null}
            {expanded || isDesktop ? <SimpleSummaryFooter onPaymentPage={onPaymentPage} total={total} /> : null}
            {expanded && resortDailyParkingFee && !showDueToday && onPaymentPage && !hideParkingFeeForBirthday ? (
              <SimpleSummaryParkingFeeWarning bookingSummaryParkingFee={resortDailyParkingFee} />
            ) : null}
            {expanded && showDueToday ? (
              <SimpleSummaryDue
                dueToday={dueToday}
                dueBeforeParty={dueBeforeParty}
                remainingBalanceDueDate={remainingBalanceDueDate}
                bookingSummaryParkingFee={resortDailyParkingFee}
                onPaymentPage={onPaymentPage}
                hideParkingFeeForBirthday={hideParkingFeeForBirthday}
              />
            ) : null}
          </>
        );
      }}
    </SummaryAccordion>
  );
};

export default SimpleSummary;
